import React from "react";
import { GlassesIcon } from "@fluentui/react-icons-northstar";
import { ReportFilterBase } from "./abstractions/ReportFilterBase";
import { Mode } from "../models";

export interface ModesFilterProps {
    modes: Mode[];
    onSelectedModesChanged: (modes: Mode[]) => void;
    isMobileView: boolean;
}

export const ModesFilter: React.FC<ModesFilterProps> = ({ modes, onSelectedModesChanged, isMobileView }) => {
    return (
        <ReportFilterBase
            icon={<GlassesIcon outline />}
            prefix="Widok"
            items={modes}
            multiple={false}
            onSelectedItemsChanged={(modes) => onSelectedModesChanged(modes as Mode[])}
            isMobileView={isMobileView}
        />
    );
};
